import { render, staticRenderFns } from "./ImgShowroomTable.vue?vue&type=template&id=66be8986&scoped=true&"
import script from "./ImgShowroomTable.vue?vue&type=script&lang=js&"
export * from "./ImgShowroomTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66be8986",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66be8986')) {
      api.createRecord('66be8986', component.options)
    } else {
      api.reload('66be8986', component.options)
    }
    module.hot.accept("./ImgShowroomTable.vue?vue&type=template&id=66be8986&scoped=true&", function () {
      api.rerender('66be8986', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Task/ImgShowroomTable.vue"
export default component.exports